import axios from "axios";

export const getWorkDays = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_work_days"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
